import { API_URL } from "../constans/roles";
import {
  generateFeedFile,
  loadFeedColumnsPreview,
} from "../utils/api/uploadApi";

export const FEED_ACCEPT = ".csv,.xml,.xls,.xlsx";
export const FEED_REQUIRED_FIELDS = [
  "name",
  "price",
  "old_price",
  "img",
  "link",
];
export const FEED_SET_SIZE_OPTIONS = Array.from({ length: 8 }, (_, index) => ({
  value: String(index + 1),
  txt: `${index + 1}`,
}));

export const FEED_REQUIRED_FIELD_LABELS = {
  name: "name",
  price: "price",
  old_price: "old_price",
  img: "img",
  link: "link",
};

export const FEED_INITIAL_MAPPING = {
  name: "",
  price: "",
  old_price: "",
  img: "",
  link: "",
};

export const FEED_INITIAL_RESULT = {
  feedId: "",
  fileName: "",
  sets: [],
};

function extractMessage(payload, fallbackMessage) {
  if (!payload) {
    return fallbackMessage;
  }

  if (typeof payload === "string") {
    return payload;
  }

  return payload.message || payload.error || fallbackMessage;
}

function createDownloadLink(blob, fileName) {
  const objectUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(objectUrl);
}

export async function downloadGeneratedFeed(downloadUrl, fileName) {
  const response = await fetch(`${API_URL}${downloadUrl}`);

  if (!response.ok) {
    let message = "Nie udalo sie pobrac wygenerowanego feedu";

    try {
      const payload = await response.json();
      message = extractMessage(payload, message);
    } catch (error) {
      // Keep fallback message when JSON body is missing.
    }

    throw new Error(message);
  }

  const blob = await response.blob();
  createDownloadLink(blob, fileName);
}

export function createColumnOptions(columns) {
  return (columns || []).map((columnName) => ({
    value: columnName,
    txt: columnName,
  }));
}

export function createCustomField() {
  return {
    id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    name: "",
    column: "",
  };
}

export async function handleFeedFileChange({
  file,
  setColumns,
  setInfo,
  setInfoType,
  setLoading,
  setMapping,
  setCustomFields,
  setResult,
}) {
  if (!file) {
    setColumns([]);
    setMapping(FEED_INITIAL_MAPPING);
    setCustomFields([]);
    setResult(FEED_INITIAL_RESULT);
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  setLoading(true);
  setInfo("");
  setInfoType("");
  setResult(FEED_INITIAL_RESULT);

  const response = await loadFeedColumnsPreview(formData);
  setLoading(false);

  if (!response.ok) {
    setColumns([]);
    setMapping(FEED_INITIAL_MAPPING);
    setCustomFields([]);
    setInfoType("error");
    setInfo(extractMessage(response.data, "Nie udalo sie odczytac kolumn z pliku"));
    return;
  }

  setColumns(response.data?.columns || []);
  setMapping(FEED_INITIAL_MAPPING);
  setCustomFields([]);
  setInfoType("success");
  setInfo("Kolumny z pliku zostaly odczytane. Mozesz wykonac mapowanie.");
}

export async function submitFeedGeneration({
  file,
  mapping,
  customFields,
  setSize,
  setLoading,
  setInfo,
  setInfoType,
  setResult,
}) {
  if (!file) {
    setInfoType("error");
    setInfo("Wybierz plik feedu.");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("setSize", setSize);
  formData.append("mapping", JSON.stringify(mapping));
  formData.append("customFields", JSON.stringify(customFields));

  setLoading(true);
  setInfo("");
  setInfoType("");

  const response = await generateFeedFile(formData);
  setLoading(false);

  if (!response.ok) {
    setInfoType("error");
    setInfo(extractMessage(response.data, "Nie udalo sie wygenerowac feedu"));
    return;
  }

  const nextResult = {
    feedId: response.data?.feedId || "",
    fileName: response.data?.fileName || "feed.json",
    sets: Array.isArray(response.data?.sets) ? response.data.sets : [],
    downloadUrl: response.data?.downloadUrl || "",
  };

  setResult(nextResult);
  setInfoType("success");
  setInfo("Feed zostal wygenerowany i zapisany.");

  if (nextResult.downloadUrl) {
    try {
      await downloadGeneratedFeed(nextResult.downloadUrl, nextResult.fileName);
    } catch (error) {
      setInfoType("error");
      setInfo(error.message);
    }
  }
}
